




















import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Types
import {
  IBasketProvisioningFieldsForm,
  IBlueprintField
} from "@/models/provisioning";
import { SemanticTypes } from "@/data/constants";

@Component({
  components: {
    "provision-field": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/provisionField.vue"
      )
  }
})
export default class ProductProvisionFields extends Mixins(HasValidation) {
  // Props

  @Prop({ required: true })
  public value!: IBasketProvisioningFieldsForm["provision_field_values"];

  @Prop({ required: true })
  public productFields!: IBlueprintField[];

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ required: true })
  public isLoading!: boolean;

  // Computed

  public get provisionFieldValues() {
    return this.value;
  }

  public set provisionFieldValues(value) {
    this.$emit("input", value);
  }

  public getSemanticBindings(field: IBlueprintField) {
    switch (field.semantic_type) {
      case SemanticTypes.DOMAIN_NAMES:
        return {
          ...this.$_.pick(this.$attrs, [
            "basket-id",
            "client-id",
            "currency-id",
            "coupons",
            "prices-message"
          ])
        };
      default:
        return {};
    }
  }
}
